import Menu from 'Models/Menu';

export default [
  Menu.materialInformation,
  Menu.createNewMaterial,
  Menu.materialAddNotes,
  Menu.materialHelp,
];
